import { NADIA_AVATAR_URL } from "../../lib/constants";

/**
 * NadiaAvatar - premium AI marketing director portrait.
 * Sizes: sm (32), md (48), lg (72), xl (112).
 * Set `thinking` to trigger the pulse ring, or `speaking` for a stronger glow.
 */
export function NadiaAvatar({ size = "md", thinking = false, speaking = false, className = "" }) {
  const dim =
    size === "sm" ? 32 : size === "md" ? 48 : size === "lg" ? 72 : 112;
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: dim, height: dim }}
      data-testid="nadia-avatar"
    >
      {/* Rotating conic ring - subtle at rest, brighter when speaking */}
      <div
        className="absolute inset-0 rounded-full nadia-ring"
        style={{
          background:
            "conic-gradient(from 0deg, rgba(34,211,238,0.65), rgba(139,92,246,0.65), rgba(34,211,238,0.65))",
          filter: "blur(6px)",
          opacity: speaking ? 0.8 : 0.4,
        }}
      />
      <div
        className={`relative rounded-full overflow-hidden border border-white/15 ${
          thinking ? "nadia-thinking" : ""
        }`}
        style={{ width: dim - 4, height: dim - 4 }}
      >
        <img
          src={NADIA_AVATAR_URL}
          alt="Nadia"
          className="w-full h-full object-cover"
          draggable={false}
        />
      </div>
    </div>
  );
}
